import { useCallback, useState } from 'react';
import { useAuthenticatedApiContext } from '../api/useApiClient';
import { AsyncState, useAsync } from './useAsync';
import { useAsyncEffect } from './useAsyncEffect';

interface TenantEndpointCountResult {
  endpointCount: number | undefined;
  loadTenantEndpointCount: AsyncState<void, () => Promise<void>>;
}

export const useTenantEndpointCount = (enabled: boolean): TenantEndpointCountResult => {
  const [endpointCount, setEndpointCount] = useState<number>();
  const apiClient = useAuthenticatedApiContext();

  const loadTenantEndpointCount = useAsync(
    useCallback(async (): Promise<void> => {
      if (!enabled) {
        setEndpointCount(undefined);
        return;
      }
      const response = await apiClient.getTenantEndpointCount();
      setEndpointCount(response.endpointCount);
    }, [apiClient, enabled]),
    { autoReset: true }
  );

  useAsyncEffect(loadTenantEndpointCount, [enabled]);

  return { endpointCount, loadTenantEndpointCount };
};
